import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import SignOutButton from '../components/SignOut';

const NavAuth = () => {
  return(
    <div style={{ display: 'flex', flexWrap: 'wrap', margin: 20 }}>
      <Link to='/'><span className="navItems">Home</span></Link>&nbsp;
      <Link to='/add'><span className="navItems">Add</span></Link>
      <SignOutButton />
    </div>
  )
}

const NavNonAuth = () => {
  return(
    <div style={{ display: 'flex', flexWrap: 'wrap'}}>
        <Link to='/'><span className="navItems">Home</span></Link>&nbsp;
        <Link to='/signin'><span className="navItems">Sign In</span></Link>
    </div>
  )
}
const Nav = (props, { authUser }) => (
  <div>
    {
      authUser ? 
      <NavAuth /> 
      :<NavNonAuth />
    }
  </div>
  )

  Nav.contextTypes = {
    authUser: PropTypes.object,
  };
  export default Nav;


// WEBPACK FOOTER //
// ./src/components/Nav.js